// src/constants/index.js
export const COLORS = {
  primary: 'var(--primary-color, #084B83)',//previous color #174540,
  secondary: 'var(--secondary-color, #42BFDD)',// previous color #48555b, //fc4c00
    third:'#202f59', // blue foncé
    darkBlue:'#171340',
    white: '#ffffff',
    black: '#000000',
    gray: {
      100: '#f7fafc',
      200: '#edf2f7',
      300: '#e2e8f0',
      400: '#cbd5e0',
      500: '#a0aec0',
      600: '#718096',
      700: '#4a5568',
      800: '#2d3748',
      900: '#1a202c',
    },
    error: '#e53e3e',
    success: '#38a169',
  };
  
  export const ROUTES = {
    home: '/',
    login: '/login',
    signup: '/signup',
    admin : '/admin',
    adminProducts : '/admin/products',
  };
  
  export const STORAGE_KEYS = {
    rememberMe: 'auth_remember_me',
    user: 'auth_user',
  };